import { Heading, Image, Paragraph } from '@zillow/constellation-10';
import { usePropertyInfoQuery } from '../../../utils/queries';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';
import Confirmation from '../../../../../images/confirmation.svg';

export default function YourLinkWasSent() {
  const { propertyId } = useLeasingUrlParams();

  const propertyInfoQuery = usePropertyInfoQuery(propertyId);

  return (
    <>
      <Image
        src={Confirmation}
        alt="person holding a pen and writing on paper inside folder"
        css={{ height: '160px', width: '160px', marginBottom: 'loose' }}
      />
      <Heading level={2} css={{ textStyle: 'responsive.heading-md', marginBottom: 'loose' }}>
        You’re all set
      </Heading>
      <Paragraph css={{ marginBottom: 'loose' }}>
        We’ll save your property and rental history in case you decide to start renting{' '}
        {propertyInfoQuery?.data?.streetAddress}
        {propertyInfoQuery?.data?.unit ? ` #${propertyInfoQuery.data.unit}` : ''} again.
      </Paragraph>
    </>
  );
}
